import {
  Inject,
  Injectable,
  Optional,
  signal,
  type WritableSignal,
} from '@angular/core';

import {
  SIMPLE_PROGRESSIVE_FORMS_CONFIG,
  SimpleProgressiveFormsConfig,
} from '../models/simple-progressive-forms-config.model';

@Injectable()
export class SimpleProgressiveFormsConfigService {
  readonly scrollIntoViewWhenActive: WritableSignal<boolean>;
  readonly enableAutomaticFocusing: WritableSignal<boolean>;
  readonly totalStepsInFlow: WritableSignal<number>;

  constructor(
    @Optional()
    @Inject(SIMPLE_PROGRESSIVE_FORMS_CONFIG)
    private readonly config: SimpleProgressiveFormsConfig | null
  ) {
    this.scrollIntoViewWhenActive = signal(
      this.config?.scrollIntoViewWhenActive ?? false
    );
    this.enableAutomaticFocusing = signal(
      this.config?.enableAutomaticFocusing ?? false
    );
    this.totalStepsInFlow = signal(this.config?.totalStepsInFlow ?? NaN);
  }
}
